module.exports = __webpack_public_path__ + "static/portrait_yan-2778ef424cc8d904f99edac30941327a.jpg";